import type { Ref } from 'react'

type RefCleanup = () => void

function setRef<T>(ref: Ref<T> | undefined, value: T | null): void | RefCleanup {
  if (typeof ref === 'function') {
    return ref(value)
  }

  if (ref) {
    (ref as { current: T | null }).current = value
  }
}

export function mergeRefs<T>(...refs: Array<Ref<T> | undefined>): (node: T | null) => void | RefCleanup {
  return (node) => {
    const cleanups = refs.map(ref => setRef(ref, node))

    if (!cleanups.some(cleanup => typeof cleanup === 'function')) {
      return undefined
    }

    return () => {
      refs.forEach((ref, index) => {
        const cleanup = cleanups[index]

        if (typeof cleanup === 'function') {
          cleanup()
        }
        else {
          setRef(ref, null)
        }
      })
    }
  }
}
